import { useLocation, useNavigate } from 'react-router-dom';

import { hapticFeedback, useLaunchParams } from '@telegram-apps/sdk-react';
import { Tabbar } from '@telegram-apps/telegram-ui';

import { menuItems } from '../model/menu-items';
import { useTranslation } from 'react-i18next';

export const BottomBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tgWebAppPlatform } = useLaunchParams();

  let paddingBottom = '0px';
  let paddingTop = '0px';

  if (['tdesktop', 'macos'].includes(tgWebAppPlatform)) {
    paddingBottom = '4px';
    paddingTop = '106px';
  } else if (tgWebAppPlatform === 'android') {
    paddingBottom = '2px';
    paddingTop = '88px';
  } else {
    paddingBottom = '20px';
    paddingTop = '80px';
  }

  const { t } = useTranslation();

  return (
    <div style={{ paddingTop: paddingTop }}>
      <div className="fixed bottom-0 left-0 z-50 w-full">
        <Tabbar style={{ paddingBottom: paddingBottom, background: 'var(--tabbar-bg)', backdropFilter: 'blur(9px)' }}>
          {menuItems.map((item, index) => (
            <Tabbar.Item
              key={index}
              text={t(`navigation.${item.key}`)}
              selected={location.pathname === item.path}
              onClick={() => {
                navigate(item.path);
                hapticFeedback.selectionChanged();
              }}
            >
              {item.icon}
            </Tabbar.Item>
          ))}
        </Tabbar>
      </div>
    </div>
  );
};
